const permissionConstants = {
  ABILITY_ACT_ACCESS_DEVICE_SECTION_ACTION: 'ability.act.REBDeviceSection',
  ABILITY_ACT_ACCESS_PRIVILEGED_DEVICES: 'ability.act.AccessPrivilegedDevices',
  ABILITY_ACT_ACCESS_RESPONSE_CONTRIBUTION_ACTION:
    'ability.act.REBResponseContributionAction',
  ABILITY_ACT_ADD_ATTACHMENT_TO_LAYOUT: 'ability.act.REBLayoutAddAttachments',
  ABILITY_ACT_ADD_CONFERENCE_TO_LAYOUT:
    'ability.act.REBLayoutAddConferenceBridge',
  ABILITY_ACT_ADD_HANDLING_TO_LAYOUT: 'ability.act.REBLayoutAddHandling',
  ABILITY_ACT_ADD_PERSON_PROPERTIES: 'ability.act.REBMessagePersonProperties',
  ABILITY_ACT_ADD_RECIPIENT_TO_LAYOUT: 'ability.act.REBLayoutRecipient',
  ABILITY_ACT_ADD_SRECIPIENT_TO_LAYOUT: 'ability.act.REBLayoutAddSRecipients',
  ABILITY_ACT_ADD_USER_UPLOAD: 'ability.act.AddUserUpload',
  ABILITY_ACT_ADDCOMPANYADMINISTRATORS: 'ability.act.AddCompanyAdministrators',
  ABILITY_ACT_COMPANY_SUPERVISOR: 'ability.act.CompanySupervisor',
  ABILITY_ACT_CREATE_APPLICATION: 'ability.act.CreateApplication',
  ABILITY_ACT_CREATE_MESSAGE_PANEL: 'ability.act.CreateMessagePanel',
  ABILITY_ACT_CREATE_REB_EVENT_WEBSERVICE:
    'ability.act.REBCreateEventWebService',
  ABILITY_ACT_CREATE_SERVICE: 'ability.act.createService',
  ABILITY_ACT_CREATEMESSAGEPANEL: 'ability.act.CreateMessagePanel',
  ABILITY_ACT_DELETE_AGENTS: 'ability.act.DeleteAgents',
  ABILITY_ACT_DELETE_ALL_SCHEDULED_MESSAGES:
    'ability.act.DeleteAllScheduledMessages',
  ABILITY_ACT_DELETE_APPLICATION: 'ability.act.DeleteApplication',
  ABILITY_ACT_DELETE_CONFERENCE_BRIDGES: 'ability.act.DeleteConferenceBridges',
  ABILITY_ACT_DELETE_DASHBOARDS: 'ability.act.DeleteDashboards',
  ABILITY_ACT_DELETE_MESSAGE_PANEL: 'ability.act.DeleteMessagePanel',
  ABILITY_ACT_DELETE_TTS_DICTIONARY: 'ability.act.DeleteTTSDictionary',
  ABILITY_ACT_DELETEALLSCHEDULEDMESSAGES:
    'ability.act.DeleteAllScheduledMessages',
  ABILITY_ACT_DELETEAPPLICATION: 'ability.act.DeleteApplication',
  ABILITY_ACT_DELETECONFERENCEBRIDGES: 'ability.act.DeleteConferenceBridges',
  ABILITY_ACT_DELETEDASHBOARDS: 'ability.act.DeleteDashboards',
  ABILITY_ACT_DELETEEVENTDOMAIN: 'ability.act.DeleteEventDomain',
  ABILITY_ACT_DELETEGROUPPROFILE: 'ability.act.DeleteGroupProfile',
  ABILITY_ACT_DELETEMESSAGEPANEL: 'ability.act.DeleteMessagePanel',
  ABILITY_ACT_DELETEPERSONPROFILE: 'ability.act.DeletePersonProfile',
  ABILITY_ACT_DELETEPROPERTY: 'ability.act.DeleteProperty',
  ABILITY_ACT_DELETESHAREDLIST: 'ability.act.DeleteSharedList',
  ABILITY_ACT_DELETESUBSCRIPTIONFORM: 'ability.act.DeleteSubscriptionForm',
  ABILITY_ACT_DELETETTSDICTIONARY: 'ability.act.DeleteTTSDictionary',
  ABILITY_ACT_DEPLOY_REB_FORM: 'ability.act.REBDeployForm',
  ABILITY_ACT_DEVELOPER: 'ability.act.Developer',
  ABILITY_ACT_EDIT_AGENTS: 'ability.act.EditAgents',
  ABILITY_ACT_EDIT_ALL_SCHEDULED_MESSAGES:
    'ability.act.EditAllScheduledMessages',
  ABILITY_ACT_EDIT_ALL_SUBSCRIPTIOINS: 'ability.act.EditAllSubscriptions',
  ABILITY_ACT_EDIT_ALL_WORKFLOWS: 'ability.act.EditAllWorkflows',
  ABILITY_ACT_EDIT_ANY_GROUP: 'ability.act.EditAnyGroup',
  ABILITY_ACT_EDIT_APPLICATION: 'ability.act.EditApplication',
  ABILITY_ACT_EDIT_CONFERENCE_BRIDGES: 'ability.act.EditConferenceBridges',
  ABILITY_ACT_EDIT_DASHBOARDS: 'ability.act.EditDashboards',
  ABILITY_ACT_EDIT_GROUP_NAME: 'ability.act.EditGroupName',
  ABILITY_ACT_EDIT_GROUP_PROFILE: 'ability.act.EditGroupProfile',
  ABILITY_ACT_EDIT_MY_DETAILS: 'ability.edit.mydetails',
  ABILITY_ACT_EDIT_PERSON_PROFILE: 'ability.act.EditPersonProfile',
  ABILITY_ACT_EDIT_TTS_DICTIONARY: 'ability.act.EditTTSDictionary',
  ABILITY_ACT_EDITALLSCHEDULEDMESSAGES: 'ability.act.EditAllScheduledMessages',
  ABILITY_ACT_EDITALLSUBSCRIPTIONS: 'ability.act.EditAllSubscriptions',
  ABILITY_ACT_EDITANYGROUP: 'ability.act.EditAnyGroup',
  ABILITY_ACT_EDITAPPLICATION: 'ability.act.EditApplication',
  ABILITY_ACT_EDITBASICCOMPANYDETAILS: 'ability.act.EditBasicCompanyDetails',
  ABILITY_ACT_EDITCONFERENCEBRIDGES: 'ability.act.EditConferenceBridges',
  ABILITY_ACT_EDITDASHBOARDS: 'ability.act.EditDashboards',
  ABILITY_ACT_EDITGROUPNAME: 'ability.act.EditGroupName',
  ABILITY_ACT_EDITGROUPPROFILE: 'ability.act.EditGroupProfile',
  ABILITY_ACT_EDITGROUPPROPERTYVALUES: 'ability.act.EditGroupPropertyValues',
  ABILITY_ACT_EDITMESSAGEPANEL: 'ability.act.EditMessagePanel',
  ABILITY_ACT_EDITPERSONPROFILE: 'ability.act.EditPersonProfile',
  ABILITY_ACT_EDITPERSONPROPERTYVALUES: 'ability.act.EditPersonPropertyValues',
  ABILITY_ACT_EDITPROPERTY: 'ability.act.EditProperty',
  ABILITY_ACT_EDITSHAREDLIST: 'ability.act.EditSharedList',
  ABILITY_ACT_EDITSUBSCRIPTIONFORM: 'ability.act.EditSubscriptionForm',
  ABILITY_ACT_EDITTTSDICTIONARY: 'ability.act.EditTTSDictionary',
  ABILITY_ACT_EDITLIVECALLROUTING: 'ability.act.EditLiveCallRouting',
  ABILITY_ACT_EVENT_ADMINISTRATION: 'ability.act.EventAdministration',
  ABILITY_ACT_EVENTADMINISTRATION: 'ability.act.EventAdministration',
  ABILITY_ACT_GROUP_SUPERVISOR: 'ability.act.GroupSupervisor',
  ABILITY_ACT_GROUPSUPERUSER: 'ability.act.GroupSuperUser',
  ABILITY_ACT_GROUPSUPERVISOR: 'ability.act.GroupSupervisor',
  ABILITY_ACT_HOST_PROXY_USER: 'ability.act.host.ProxyUser',
  ABILITY_ACT_IMPORT_APPLICATION: 'ability.act.ImportApplication',
  ABILITY_ACT_IMPORTAPPLICATION: 'ability.act.ImportApplication',
  ABILITY_ACT_INITIATESCENARIOS: 'ability.act.InitiateScenarios',
  ABILITY_ACT_LOGIN_AS_AGENT: 'ability.act.LoginAsAgent',
  ABILITY_ACT_LOGINASAGENT: 'ability.act.LoginAsAgent',
  ABILITY_ACT_MANAGE_DEVICE_NAMES: 'ability.act.ManageDeviceNames',
  ABILITY_ACT_MANAGE_EXTERNALLY_OWNED: 'ability.act.ManageExternallyOwned',
  ABILITY_ACT_MANAGEEXTERNALLYOWNED: 'ability.act.ManageExternallyOwned',
  ABILITY_ACT_MANAGE_HOLIDAYS: 'ability.act.ManageHolidays',
  ABILITY_ACT_MANAGE_PASSWORD_POLICY: 'ability.act.ManagePasswordPolicy',
  ABILITY_ACT_MANAGE_STAKEHOLDER_USERS: 'ability.act.ManageStakeholderUsers',
  ABILITY_ACT_MANAGE_TASKLISTS: 'ability.act.ManageTaskLists',
  ABILITY_ACT_MANAGE_TTS_DICTIONARY: 'ability.act.ManageTTSDictionary',
  ABILITY_ACT_MANAGE_USER_PROPERTIES: 'ability.act.ManageUserProperties',
  ABILITY_ACT_MANAGE_INCIDENT_TYPES: 'ability.act.ManageIncidentTypes',
  ABILITY_ACT_MANAGE_VOICE_RECORDINGS: 'ability.act.ManageVoiceRecordings',
  ABILITY_ACT_NOTIFICATIONREPORT: 'ability.act.NotificationReport',
  ABILITY_ACT_OPERATIONS: 'ability.act.Operations',
  ABILITY_ACT_OVERRIDESAMLSSOLOGIN: 'ability.act.OverrideSamlSsoLogin',
  ABILITY_ACT_PERSON_SUPERVISOR: 'ability.act.PersonSupervisor',
  ABILITY_ACT_PERSONSUPERVISOR: 'ability.act.PersonSupervisor',
  ABILITY_ACT_PRESS_ANY_KEY: 'ability.act.REBPressAnyKey',
  ABILITY_ACT_REASSIGN_FLOW_STEP_OWNER: 'ability.act.ReassignFlowStepOwner',
  ABILITY_ACT_REB_ACTIVITY_UPDATES: 'ability.act.REBActivityUpdates',
  ABILITY_ACT_REB_SCENARIOS: 'ability.act.REBScenarios',
  ABILITY_ACT_REBACTIVITYUPDATES: 'ability.act.REBActivityUpdates',
  ABILITY_ACT_REBCREATEEVENTWEBSERVICE: 'ability.act.REBCreateEventWebService',
  ABILITY_ACT_REBDEPLOYFORM: 'ability.act.REBDeployForm',
  ABILITY_ACT_REBDEVICESECTION: 'ability.act.REBDeviceSection',
  ABILITY_ACT_REBLAYOUTADDATTACHMENTS: 'ability.act.REBLayoutAddAttachments',
  ABILITY_ACT_REBLAYOUTADDCONFERENCEBRIDGE:
    'ability.act.REBLayoutAddConferenceBridge',
  ABILITY_ACT_REBLAYOUTADDHANDLING: 'ability.act.REBLayoutAddHandling',
  ABILITY_ACT_REBLAYOUTADDSRECIPIENTS: 'ability.act.REBLayoutAddSRecipients',
  ABILITY_ACT_REBLAYOUTRECIPIENT: 'ability.act.REBLayoutRecipient',
  ABILITY_ACT_REBMESSAGEPERSONPROPERTIES:
    'ability.act.REBMessagePersonProperties',
  ABILITY_ACT_REBRESPONSECONTRIBUTIONACTION:
    'ability.act.REBResponseContributionAction',
  ABILITY_ACT_REBSCENARIOS: 'ability.act.REBScenarios',
  ABILITY_ACT_SUBSCRIPTIONMANAGER: 'ability.act.SubscriptionManager',
  ABILITY_ACT_SUPERVISESCENARIO: 'ability.act.SuperviseScenario',
  ABILITY_ACT_SUPPORTUSER: 'ability.act.SupportUser',
  ABILITY_ACT_SYSTEMNOTIFICATIONREPORT: 'ability.act.SystemNotificationReport',
  ABILITY_ACT_UNLOCK_ACCOUNT: 'ability.act.UnlockAccount',
  ABILITY_ACT_UNLOCKACCOUNT: 'ability.act.UnlockAccount',
  ABILITY_ACT_VIEW_ALL_EVENTS: 'ability.act.ViewAllEvents',
  ABILITY_ACT_VIEW_ALL_SCHEDULED_MESSAGES:
    'ability.act.ViewAllScheduledMessages',
  ABILITY_ACT_VIEW_ALL_SUBSCRIPTIONS: 'ability.act.ViewAllSubscriptions',
  ABILITY_ACT_VIEW_APPLICATIONS: 'ability.act.ViewApplication',
  ABILITY_ACT_VIEW_BASIC_COMPANY_DETAILS: 'ability.act.ViewBasicCompanyDetails',
  ABILITY_ACT_VIEW_CONFERENCE_BRIDGES: 'ability.act.ViewConferenceBridges',
  ABILITY_ACT_VIEW_DASHBOARDS: 'ability.act.ViewDashboards',
  ABILITY_ACT_VIEW_GROUP_PROPERTY_VALUES: 'ability.act.ViewGroupPropertyValues',
  ABILITY_ACT_VIEW_GROUP_PERFORMANCE_WIDGET:
    'ability.act.ViewGroupPerformanceWidget',
  ABILITY_ACT_VIEW_INCIDENT_SEVERITY: 'ability.act.ViewIncidentSeverity',
  ABILITY_ACT_VIEW_INCIDENTS: 'ability.act.ViewIncidents',
  ABILITY_ACT_EDIT_INCIDENTS: 'ability.act.EditIncidents',
  ABILITY_ACT_VIEW_PERSON_PROPERTY_VALUES:
    'ability.act.ViewPersonPropertyValues',
  ABILITY_ACT_VIEW_STACK_TRACES: 'ability.act.ViewStackTraces',
  ABILITY_ACT_VIEW_SUBSCRIPTION_FORM: 'ability.act.ViewSubscriptionForm',
  ABILITY_ACT_VIEW_TTS_DICTIONARY: 'ability.act.ViewTTSDictionary',
  ABILITY_ACT_VIEW_TTSDICTIONARY: 'ability.act.ViewTTSDictionary',
  ABILITY_ACT_VIEWALLEVENTS: 'ability.act.ViewAllEvents',
  ABILITY_ACT_VIEWALLSCHEDULEDMESSAGES: 'ability.act.ViewAllScheduledMessages',
  ABILITY_ACT_VIEWALLSUBSCRIPTIONS: 'ability.act.ViewAllSubscriptions',
  ABILITY_ACT_VIEWAPPLICATION: 'ability.act.ViewApplication',
  ABILITY_ACT_VIEWBASICCOMPANYDETAILS: 'ability.act.ViewBasicCompanyDetails',
  ABILITY_ACT_VIEWCONFERENCEBRIDGES: 'ability.act.ViewConferenceBridges',
  ABILITY_ACT_VIEWDASHBOARDS: 'ability.act.ViewDashboards',
  ABILITY_ACT_VIEWGROUPPROFILE: 'ability.act.ViewGroupProfile',
  ABILITY_ACT_VIEWGROUPPROPERTYVALUES: 'ability.act.ViewGroupPropertyValues',
  ABILITY_ACT_VIEWMESSAGEPANEL: 'ability.act.ViewMessagePanel',
  ABILITY_ACT_VIEWPERSONPROFILE: 'ability.act.ViewPersonProfile',
  ABILITY_ACT_VIEWPERSONPROPERTYVALUES: 'ability.act.ViewPersonPropertyValues',
  ABILITY_ACT_VIEWPHONERECORDINGS: 'ability.act.ViewPhoneRecordings',
  ABILITY_ACT_VIEWPROPERTY: 'ability.act.ViewProperty',
  ABILITY_ACT_VIEWSHAREDLIST: 'ability.act.ViewSharedList',
  ABILITY_ACT_VIEWSTACKTRACES: 'ability.act.ViewStackTraces',
  ABILITY_ACT_VIEWSUBSCRIPTIONFORM: 'ability.act.ViewSubscriptionForm',
  ABILITY_ACT_VIEWSYSTEMEVENTS: 'ability.act.ViewSystemEvents',
  ABILITY_ACT_VIEWTTSDICTIONARY: 'ability.act.ViewTTSDictionary',
  ABILITY_ACT_WEBSERVICE_SERVICEPROVIDERUSER:
    'ability.act.WebService.ServiceProviderUser',
  ABILITY_ACT_WEBSERVICE: 'ability.act.WebService',
  ABILITY_ACT_MANAGEFLOODCONTROL: 'ability.act.ManageFloodControl',
  ABILITY_DELETE_SCENARIO_ALL: 'ability.delete.scenario.all',
  ABILITY_EDIT_MYDETAILS: 'ability.edit.mydetails',
  ABILITY_EDIT_MY_DEVICES: 'ability.edit.MyDevices',
  ABILITY_EDIT_SCENARIO_ALL: 'ability.edit.scenario.all',
  ABILITY_INITIATE_SCENARIO_ALL: 'ability.initiate.scenario.all',
  ABILITY_MANAGE_PROXY: 'ability.manage.Proxy',
  ABILITY_OVERRIDE_EXTERNALDATALOCK: 'ability.override.ExternalDataLock',
  VIEW_MENU_ADMIN: 'view.menu.Admin',
  VIEW_MENU_ALERTS: 'view.menu.Alerts',
  VIEW_MENU_CAPI_EVENT_REPORT: 'view.menuitem.CAPIEventReport',
  VIEW_MENU_CAPI_NOTIFICATION_REPORT: 'view.menuitem.CAPINotificationReport',
  VIEW_MENU_DEVELOPER: 'view.menu.Developer',
  VIEW_MENU_GROUPS: 'view.menu.Groups',
  VIEW_MENU_MESSAGING: 'view.menu.Messaging',
  VIEW_MENU_MY_PROFILE: 'view.menu.MyProfile',
  VIEW_MENU_MYPROFILE: 'view.menu.MyProfile',
  VIEW_MENU_REPORTING: 'view.menu.Reporting',
  VIEW_MENUITEM_SERVICES: 'view.menuitem.Services',
  VIEW_MENU_USERS: 'view.menu.Users',
  VIEW_MENUITEM_ACTIVEALERTS: 'view.menuitem.ActiveAlerts',
  VIEW_MENUITEM_ADD_PHONE_RECORDINGS: 'view.menuitem.AddPhoneRecordings',
  VIEW_MENUITEM_ADD_SCENARIO: 'view.menuitem.AddScenario',
  VIEW_MENUITEM_ADDPHONERECORDINGS: 'view.menuitem.AddPhoneRecordings',
  VIEW_MENUITEM_ADDSCENARIO: 'view.menuitem.AddScenario',
  VIEW_MENUITEM_APPLICATION_MANAGER: 'view.menuitem.ApplicationManager',
  VIEW_MENUITEM_APPLICATIONMANAGER: 'view.menuitem.ApplicationManager',
  VIEW_MENUITEM_B2C_EVENT_ACTIVITY_REPORT: 'view.menuitem.CAPIEventReport',
  VIEW_MENUITEM_CHANGEWEBSERVICEUSERPASSWORD:
    'view.menuitem.ChangeWebServiceUserPassword',
  VIEW_MENUITEM_CLEAR_RUNTIME_HISTORY: 'view.menuitem.ClearRuntimeHistory',
  VIEW_MENUITEM_CLEARRUNTIMEHISTORY: 'view.menuitem.ClearRuntimeHistory',
  VIEW_MENUITEM_CLUSTER: 'view.menuitem.Cluster',
  VIEW_MENUITEM_CNSREGISTRYACCESSCONTROL:
    'view.menuitem.CnsRegistryAccessControl',
  VIEW_MENUITEM_COMPANIES: 'view.menuitem.Companies',
  VIEW_MENUITEM_COMPANY_ADMINS: 'view.menuitem.CompanyAdmins',
  VIEW_MENUITEM_COMPANY_HOLIDAYS: 'view.menuitem.CompanyHolidays',
  VIEW_MENUITEM_COMPANY_REPORTS: 'view.menuitem.CompanyReports',
  VIEW_MENUITEM_COMPANYADMINS: 'view.menuitem.CompanyAdmins',
  VIEW_MENUITEM_COMPANYHOLIDAYS: 'view.menuitem.CompanyHolidays',
  VIEW_MENUITEM_COMPANYREPORTS: 'view.menuitem.CompanyReports',
  VIEW_MENUITEM_COMPONENT_STATUS_SUMMARY_REPORT:
    'view.menuitem.ComponentStatusSummaryReport',
  VIEW_MENUITEM_COMPONENTSTATUSSUMMARYREPORT:
    'view.menuitem.ComponentStatusSummaryReport',
  VIEW_MENUITEM_COUNTRIES: 'view.menuitem.Countries',
  VIEW_MENUITEM_CUSTOM_ATTRIBUTES: 'view.menuitem.CustomAttributes',
  VIEW_MENUITEM_CUSTOM_FIELDS: 'view.menuitem.CustomFields',
  VIEW_MENUITEM_CUSTOM_HOLIDAYS: 'view.menuitem.CustomHolidays',
  VIEW_MENUITEM_CUSTOM_MESSAGING_PANEL: 'view.menuitem.CustomMessagingPanel',
  VIEW_MENUITEM_CUSTOM_MESSAGING_PANELS: 'view.menuitem.CustomMessagingPanels',
  VIEW_MENUITEM_CUSTOMATTRIBUTES: 'view.menuitem.CustomAttributes',
  VIEW_MENUITEM_CUSTOMFIELDS: 'view.menuitem.CustomFields',
  VIEW_MENUITEM_CUSTOMHOLIDAYS: 'view.menuitem.CustomHolidays',
  VIEW_MENUITEM_CUSTOMMESSAGINGPANEL: 'view.menuitem.CustomMessagingPanel',
  VIEW_MENUITEM_CUSTOMMESSAGINGPANELS: 'view.menuitem.CustomMessagingPanels',
  VIEW_MENUITEM_DYNAMIC_TEAMS: 'view.menuitem.DynamicTeams',
  VIEW_MENUITEM_DYNAMICTEAMS: 'view.menuitem.DynamicTeams',
  VIEW_MENUITEM_EPICSTATUS_REPORT_OPERATIONS:
    'view.menuitem.EPICStatusReportOperations',
  VIEW_MENUITEM_EPICSTATUS_REPORT: 'view.menuitem.EPICStatusReport',
  VIEW_MENUITEM_EPICSTATUSREPORT: 'view.menuitem.EPICStatusReport',
  VIEW_MENUITEM_EPICSTATUSREPORTOPERATIONS:
    'view.menuitem.EPICStatusReportOperations',
  VIEW_MENUITEM_EVENT_ACTIVITY_REPORT: 'view.menuitem.EventActivityReport',
  VIEW_MENUITEM_EVENT_DOMAIN_CONSTANTS: 'view.menuitem.EventDomainConstants',
  VIEW_MENUITEM_EVENT_DOMAINS: 'view.menuitem.EventDomains',
  VIEW_MENUITEM_EVENTACTIVITYREPORT: 'view.menuitem.EventActivityReport',
  VIEW_MENUITEM_EVENTDOMAINCONSTANTS: 'view.menuitem.EventDomainConstants',
  VIEW_MENUITEM_EVENTDOMAINS: 'view.menuitem.EventDomains',
  VIEW_MENUITEM_EXTERNAL_DATA: 'view.menuitem.ExternalData',
  VIEW_MENUITEM_EXTERNALDATA: 'view.menuitem.ExternalData',
  VIEW_MENUITEM_FAST_ACCESS_SCENARIOS: 'view.menuitem.FastAccessScenarios',
  VIEW_MENUITEM_FASTACCESSSCENARIOS: 'view.menuitem.FastAccessScenarios',
  VIEW_MENUITEM_FAVOURITE_SCENARIOS: 'view.menuitem.FavouriteScenarios',
  VIEW_MENUITEM_FAVOURITESCENARIOS: 'view.menuitem.FavouriteScenarios',
  VIEW_MENUITEM_FIND_DYNAMIC_TEAMS: 'view.menuitem.FindDynamicTeams',
  VIEW_MENUITEM_FIND_SCENARIOS: 'view.menuitem.FindScenarios',
  VIEW_MENUITEM_FINDDYNAMICTEAMS: 'view.menuitem.FindDynamicTeams',
  VIEW_MENUITEM_FINDSCENARIOS: 'view.menuitem.FindScenarios',
  VIEW_MENUITEM_FUNCTIONS: 'view.menuitem.Functions',
  VIEW_MENUITEM_GLOBAL_PARAMETERS: 'view.menuitem.GlobalParameters',
  VIEW_MENUITEM_GLOBALPARAMETERS: 'view.menuitem.GlobalParameters',
  VIEW_MENUITEM_GLOBALSYSTEMMESSAGEPANEL:
    'view.menuitem.GlobalSystemMessagePanel',
  VIEW_MENUITEM_GROUP_PERFORMANCE_REPORT:
    'view.menuitem.GroupPerformanceReport',
  VIEW_MENUITEM_GROUPPERFORMANCEREPORT: 'view.menuitem.GroupPerformanceReport',
  VIEW_MENUITEM_GROUPS: 'view.menuitem.Groups',
  VIEW_MENUITEM_IMPORT_DATA: 'view.menuitem.ImportData',
  VIEW_MENUITEM_IMPORTDATA: 'view.menuitem.ImportData',
  VIEW_MENUITEM_IMPORT_JOB_HISTORY_REPORT:
    'view.menuitem.ImportJobHistoryReport',
  VIEW_MENUITEM_INTEGRATION_AGENT_ACCESS_CONTROL:
    'view.menuitem.IntegrationAgentAccessControl',
  VIEW_MENUITEM_INTEGRATIONAGENTACCESSCONTROL:
    'view.menuitem.IntegrationAgentAccessControl',
  VIEW_MENUITEM_JOB_TYPE_SELECTOR: 'view.menuitem.JobTypeSelector',
  VIEW_MENUITEM_JOBTYPESELECTOR: 'view.menuitem.JobTypeSelector',
  VIEW_MENUITEM_LANGUAGES: 'view.menuitem.Languages',
  VIEW_MENUITEM_LICENSES: 'view.menuitem.Licenses',
  VIEW_MENUITEM_MESSAGE_DOMAINS: 'view.menuitem.MessageDomains',
  VIEW_MENUITEM_MESSAGEDOMAINS: 'view.menuitem.MessageDomains',
  VIEW_MENUITEM_MY_COMPANY_DETAILS: 'view.menuitem.MyCompanyDetails',
  VIEW_MENUITEM_MY_DEVICES: 'view.menuitem.MyDevices',
  VIEW_MENUITEM_MY_SUBSCRIPTIONS: 'view.menuitem.MySubscriptions',
  VIEW_MENUITEM_MYCOMPANYDETAILS: 'view.menuitem.MyCompanyDetails',
  VIEW_MENUITEM_MYDEVICES: 'view.menuitem.MyDevices',
  VIEW_MENUITEM_MYSUBSCRIPTIONS: 'view.menuitem.MySubscriptions',
  VIEW_MENUITEM_NODE: 'view.menuitem.Node',
  VIEW_MENUITEM_NOTIFICATION_REPORT: 'view.menuitem.NotificationReport',
  VIEW_MENUITEM_NOTIFICATION_THROUGHPUT: 'view.menuitem.NotificationThroughput',
  VIEW_MENUITEM_NOTIFICATIONREPORT: 'view.menuitem.NotificationReport',
  VIEW_MENUITEM_NOTIFICATIONTHROUGHPUT: 'view.menuitem.NotificationThroughput',
  VIEW_MENUITEM_PASSWORD_POLICY: 'view.menuitem.PasswordPolicy',
  VIEW_MENUITEM_PASSWORDPOLICY: 'view.menuitem.PasswordPolicy',
  VIEW_MENUITEM_PHONE_RECORDINGS: 'view.menuitem.PhoneRecordings',
  VIEW_MENUITEM_PHONERECORDINGS: 'view.menuitem.PhoneRecordings',
  VIEW_MENUITEM_PROTOCOL_LEVEL_PROVIDERS:
    'view.menuitem.ProtocolLevelProviders',
  VIEW_MENUITEM_PROTOCOLLEVELPROVIDERS: 'view.menuitem.ProtocolLevelProviders',
  VIEW_MENUITEM_QUOTAS: 'view.menuitem.Quotas',
  VIEW_MENUITEM_REPORTS_ACTIVITY: 'view.menuitem.ReportsActivity',
  VIEW_MENUITEM_REPORTSACTIVITY: 'view.menuitem.ReportsActivity',
  VIEW_MENUITEM_ROLES: 'view.menuitem.Roles',
  VIEW_MENUITEM_SEARCH_WEB_SERVICE_USERS: 'view.menuitem.SearchWebServiceUsers',
  VIEW_MENUITEM_SEARCHWEBSERVICEUSERS: 'view.menuitem.SearchWebServiceUsers',
  VIEW_MENUITEM_SECURITY_AUDIT_REPORT: 'view.menuitem.SecurityAuditReport',
  VIEW_MENUITEM_SECURITYAUDITREPORT: 'view.menuitem.SecurityAuditReport',
  VIEW_MENUITEM_SITES: 'view.menuitem.Sites',
  VIEW_MENUITEM_SUBSCRIPTION_DOMAINS: 'view.menuitem.SubscriptionDomains',
  VIEW_MENUITEM_SUBSCRIPTIONDOMAINS: 'view.menuitem.SubscriptionDomains',
  VIEW_MENUITEM_SUPERADMINISTRATORS: 'view.menuitem.SuperAdministrators',
  VIEW_MENUITEM_SYSTEM_APPLICATIONS: 'view.menuitem.SystemApplications',
  VIEW_MENUITEM_SYSTEM_AUDIT_REPORT: 'view.menuitem.SystemAuditReport',
  VIEW_MENUITEM_SYSTEM_NOTIFICATION_REPORT:
    'view.menuitem.SystemNotificationReport',
  VIEW_MENUITEM_SYSTEM_REPORTS: 'view.menuitem.SystemReports',
  VIEW_MENUITEM_SYSTEMAPPLICATIONS: 'view.menuitem.SystemApplications',
  VIEW_MENUITEM_SYSTEMAUDITREPORT: 'view.menuitem.SystemAuditReport',
  VIEW_MENUITEM_SYSTEMNOTIFICATIONREPORT:
    'view.menuitem.SystemNotificationReport',
  VIEW_MENUITEM_SYSTEMREPORTS: 'view.menuitem.SystemReports',
  VIEW_MENUITEM_TIME_ZONES: 'view.menuitem.TimeZones',
  VIEW_MENUITEM_TIMEZONES: 'view.menuitem.TimeZones',
  VIEW_MENUITEM_USER_DETAILS: 'view.menuitem.UserDetails',
  VIEW_MENUITEM_USER_LEVEL_PROVIDERS: 'view.menuitem.UserLevelProviders',
  VIEW_MENUITEM_USER_PERFORMANCE_REPORT: 'view.menuitem.UserPerformanceReport',
  VIEW_MENUITEM_USERDETAILS: 'view.menuitem.UserDetails',
  VIEW_MENUITEM_USERLEVELPROVIDERS: 'view.menuitem.UserLevelProviders',
  VIEW_MENUITEM_USERPERFORMANCEREPORT: 'view.menuitem.UserPerformanceReport',
  VIEW_MENUITEM_USERS: 'view.menuitem.Users',
  VIEW_MENUITEM_VIEW_SCHEDULED_MESSAGES: 'view.menuitem.ViewScheduledMessages',
  VIEW_MENUITEM_VIEW_SENT_MESSAGES: 'view.menuitem.ViewSentMessages',
  VIEW_MENUITEM_VIEW_SENT_SCENARIOS: 'view.menuitem.ViewSentScenarios',
  VIEW_MENUITEM_VIEW_USER_SCHEDULE: 'view.menuitem.ViewUserSchedule',
  VIEW_MENUITEM_VIEW_USERS_BY_ROLE: 'view.menuitem.ViewUsersByRole',
  VIEW_MENUITEM_VIEWSCHEDULEDMESSAGES: 'view.menuitem.ViewScheduledMessages',
  VIEW_MENUITEM_VIEWSENTMESSAGES: 'view.menuitem.ViewSentMessages',
  VIEW_MENUITEM_VIEWSENTSCENARIOS: 'view.menuitem.ViewSentScenarios',
  VIEW_MENUITEM_VIEWUSERSBYROLE: 'view.menuitem.ViewUsersByRole',
  VIEW_MENUITEM_VIEWUSERSCHEDULE: 'view.menuitem.ViewUserSchedule',
  VIEW_MENUITEM_WEB_SERVICE_USER_DETAILS: 'view.menuitem.WebServiceUserDetails',
  VIEW_MENUITEM_WEBSERVICEUSERDETAILS: 'view.menuitem.WebServiceUserDetails',
  VIEW_MENUITEM_WHOS_ON_DUTY: 'view.menuitem.WhosOnDuty',
  VIEW_MENUITEM_WHOSONDUTY: 'view.menuitem.WhosOnDuty',
  VIEW_SCREEN_ACTIVE_ALERTS: 'view.screen.ActiveAlerts',
  VIEW_SCREEN_ACTIVEALERTS: 'view.screen.ActiveAlerts',
  VIEW_SCREEN_ACTIVEALERTSFORMYGROUPS: 'view.screen.ActiveAlertsForMyGroups',
  VIEW_SCREEN_ADD_DEVICE: 'view.screen.AddDevice',
  VIEW_SCREEN_ADD_GROUP: 'view.screen.AddGroup',
  VIEW_SCREEN_ADDASSIGNEDSUBSCRIPTION: 'view.screen.AddAssignedSubscription',
  VIEW_SCREEN_ADDCUSTOMMESSAGINGPANEL: 'view.screen.AddCustomMessagingPanel',
  VIEW_SCREEN_ADDDEVICE: 'view.screen.AddDevice',
  VIEW_SCREEN_ADDDYNAMICTEAMOBSERVERS: 'view.screen.AddDynamicTeamObservers',
  VIEW_SCREEN_ADDDYNAMICTEAMSUPERVISORS:
    'view.screen.AddDynamicTeamSupervisors',
  VIEW_SCREEN_ADDGROUP: 'view.screen.AddGroup',
  VIEW_SCREEN_ADDMESSAGEDOMAIN: 'view.screen.AddMessageDomain',
  VIEW_SCREEN_ADDPHONERECORDING: 'view.screen.AddPhoneRecording',
  VIEW_SCREEN_ADDPROTOCOLLEVELPROVIDER: 'view.screen.AddProtocolLevelProvider',
  VIEW_SCREEN_ADDSUBSCRIPTIONDOMAIN: 'view.screen.AddSubscriptionDomain',
  VIEW_SCREEN_ADDSUPERADMINISTRATORDETAILS:
    'view.screen.AddSuperAdministratorDetails',
  VIEW_SCREEN_ALERTDEVICEHISTORY: 'view.screen.AlertDeviceHistory',
  VIEW_SCREEN_ALERTGROUPHISTORY: 'view.screen.AlertGroupHistory',
  VIEW_SCREEN_APPLICATION_MANAGER: 'view.screen.ApplicationManager',
  VIEW_SCREEN_APPLICATIONMANAGER: 'view.screen.ApplicationManager',
  VIEW_SCREEN_ASSIGNEDSUBSCRIPTIONDETAILS:
    'view.screen.AssignedSubscriptionDetails',
  VIEW_SCREEN_CHANGEPASSWORD: 'view.screen.ChangePassword',
  VIEW_SCREEN_CHANGEWEBSERVICEUSERPASSWORD:
    'view.screen.ChangeWebServiceUserPassword',
  VIEW_SCREEN_CLEARRUNTIMEHISTORY: 'view.screen.ClearRuntimeHistory',
  VIEW_SCREEN_CNSREGISTRYACCESSCONTROL: 'view.screen.CnsRegistryAccessControl',
  VIEW_SCREEN_COMPANIES: 'view.screen.Companies',
  VIEW_SCREEN_COMPANYADMINDETAILS: 'view.screen.CompanyAdminDetails',
  VIEW_SCREEN_COMPANYADMINS: 'view.screen.CompanyAdmins',
  VIEW_SCREEN_COMPANYDETAILS: 'view.screen.CompanyDetails',
  VIEW_SCREEN_COMPANYHOLIDAYS: 'view.screen.CompanyHolidays',
  VIEW_SCREEN_COMPANYHOLIDAYSELECTION: 'view.screen.CompanyHolidaySelection',
  VIEW_SCREEN_COMPONENTSTATUSSUMMARYREPORT:
    'view.screen.ComponentStatusSummaryReport',
  VIEW_SCREEN_CONFERENCE_BRIDGE_MANAGEMENT:
    'view.screen.ConferenceBridgeManagement',
  VIEW_SCREEN_CONFERENCEBRIDGEMANAGEMENT:
    'view.screen.ConferenceBridgeManagement',
  VIEW_SCREEN_COPYEXISTINGHOLIDAY: 'view.screen.CopyExistingHoliday',
  VIEW_SCREEN_COUNTRIES: 'view.screen.Countries',
  VIEW_SCREEN_CUSTOMATTRIBUTES: 'view.screen.CustomAttributes',
  VIEW_SCREEN_CUSTOMATTRIBUTESDETAILS: 'view.screen.CustomAttributesDetails',
  VIEW_SCREEN_CUSTOMFIELDDETAILS: 'view.screen.CustomFieldDetails',
  VIEW_SCREEN_CUSTOMFIELDS: 'view.screen.CustomFields',
  VIEW_SCREEN_CUSTOMHOLIDAYDETAILS: 'view.screen.CustomHolidayDetails',
  VIEW_SCREEN_CUSTOMHOLIDAYS: 'view.screen.CustomHolidays',
  VIEW_SCREEN_CUSTOMMESSAGINGPANEL: 'view.screen.CustomMessagingPanel',
  VIEW_SCREEN_CUSTOMMESSAGINGPANELDETAILS:
    'view.screen.CustomMessagingPanelDetails',
  VIEW_SCREEN_CUSTOMMESSAGINGPANELROLES:
    'view.screen.CustomMessagingPanelRoles',
  VIEW_SCREEN_CUSTOMMESSAGINGPANELS: 'view.screen.CustomMessagingPanels',
  VIEW_SCREEN_DEVICE_DETAILS: 'view.screen.DeviceDetails',
  VIEW_SCREEN_DEVICEDETAILS: 'view.screen.DeviceDetails',
  VIEW_SCREEN_DYNAMICTEAMDETAILS: 'view.screen.DynamicTeamDetails',
  VIEW_SCREEN_DYNAMICTEAMOBSERVERS: 'view.screen.DynamicTeamObservers',
  VIEW_SCREEN_DYNAMICTEAMS: 'view.screen.DynamicTeams',
  VIEW_SCREEN_DYNAMICTEAMSUPERVISORS: 'view.screen.DynamicTeamSupervisors',
  VIEW_SCREEN_EDIT_PERSON_SUPERVISORS: 'view.screen.EditPersonSupervisors',
  VIEW_SCREEN_EDITPERSONSUPERVISORS: 'view.screen.EditPersonSupervisors',
  VIEW_SCREEN_EDITPHONERECORDING: 'view.screen.EditPhoneRecording',
  VIEW_SCREEN_EDITSUBSCRIPTIONMANAGERS: 'view.screen.EditSubscriptionManagers',
  VIEW_SCREEN_EPICSTATUSREPORT: 'view.screen.EPICStatusReport',
  VIEW_SCREEN_EPICSTATUSREPORTOPERATIONS:
    'view.screen.EPICStatusReportOperations',
  VIEW_SCREEN_EVENT_ACTIVITY_REPORT: 'view.screen.EventActivityReport',
  VIEW_SCREEN_EVENTACTIVITYREPORT: 'view.screen.EventActivityReport',
  VIEW_SCREEN_EVENTDATAREPORT: 'view.screen.EventDataReport',
  VIEW_SCREEN_EVENTDOMAINCONSTANTS: 'view.screen.EventDomainConstants',
  VIEW_SCREEN_EVENTDOMAINDETAILS: 'view.screen.EventDomainDetails',
  VIEW_SCREEN_EVENTDOMAINPREDICATEDETAILS:
    'view.screen.EventDomainPredicateDetails',
  VIEW_SCREEN_EVENTDOMAINS: 'view.screen.EventDomains',
  VIEW_SCREEN_EXTERNALDATA: 'view.screen.ExternalData',
  VIEW_SCREEN_FASTACCESSSCENARIOS: 'view.screen.FastAccessScenarios',
  VIEW_SCREEN_FINDDYNAMICTEAMS: 'view.screen.FindDynamicTeams',
  VIEW_SCREEN_FUNCTIONDETAILS: 'view.screen.FunctionDetails',
  VIEW_SCREEN_FUNCTIONPERMISSIONS: 'view.screen.FunctionPermissions',
  VIEW_SCREEN_FUNCTIONROLES: 'view.screen.FunctionRoles',
  VIEW_SCREEN_FUNCTIONS: 'view.screen.Functions',
  VIEW_SCREEN_GLOBALSYSTEMMESSAGEPANEL: 'view.screen.GlobalSystemMessagePanel',
  VIEW_SCREEN_GROUP_DETAILS: 'view.screen.GroupDetails',
  VIEW_SCREEN_GROUP_PERFORMANCE_REPORT: 'view.screen.GroupPerformanceReport',
  VIEW_SCREEN_GROUPDETAILS: 'view.screen.GroupDetails',
  VIEW_SCREEN_GROUPPERFORMANCEREPORT: 'view.screen.GroupPerformanceReport',
  VIEW_SCREEN_GROUPS_USER_BELONGS_TO: 'view.screen.GroupsUserBelongsTo',
  VIEW_SCREEN_GROUPS: 'view.screen.Groups',
  VIEW_SCREEN_GROUPSUSERBELONGSTO: 'view.screen.GroupsUserBelongsTo',
  VIEW_SCREEN_IMPORTDATA: 'view.screen.ImportData',
  VIEW_SCREEN_IMPORT_JOB_DETAILS_REPORT: 'view.screen.ImportJobDetailsReport',
  VIEW_SCREEN_IMPORTPACKAGE: 'view.screen.ImportPackage',
  VIEW_SCREEN_INITIATESCENARIO: 'view.screen.InitiateScenario',
  VIEW_SCREEN_INTEGRATIONAGENTACCESSCONTROL:
    'view.screen.IntegrationAgentAccessControl',
  VIEW_SCREEN_INTEGRATIONSERVICEDETAILS:
    'view.screen.IntegrationServiceDetails',
  VIEW_SCREEN_INTEGRATIONSERVICEROLES: 'view.screen.IntegrationServiceRoles',
  VIEW_SCREEN_JOBTYPESELECTOR: 'view.screen.JobTypeSelector',
  VIEW_SCREEN_LANGUAGES: 'view.screen.Languages',
  VIEW_SCREEN_LICENSEFILEDETAILS: 'view.screen.LicenseFileDetails',
  VIEW_SCREEN_LICENSES: 'view.screen.Licenses',
  VIEW_SCREEN_MESSAGEDOMAINDETAILS: 'view.screen.MessageDomainDetails',
  VIEW_SCREEN_MESSAGEDOMAINPREDICATES: 'view.screen.MessageDomainPredicates',
  VIEW_SCREEN_MESSAGEDOMAINROLES: 'view.screen.MessageDomainRoles',
  VIEW_SCREEN_MESSAGEDOMAINS: 'view.screen.MessageDomains',
  VIEW_SCREEN_MY_API_KEYS: 'view.screen.MyAPIKeys',
  VIEW_SCREEN_MY_DEVICES: 'view.screen.MyDevices',
  VIEW_SCREEN_MY_ROLES: 'view.screen.MyRoles',
  VIEW_SCREEN_MY_SCHEDULES: 'view.screen.MySchedules',
  VIEW_SCREEN_MY_SUBSCRIPTIONS: 'view.screen.MySubscriptions',
  VIEW_SCREEN_MYASSIGNEDALERTS: 'view.screen.MyAssignedAlerts',
  VIEW_SCREEN_MYCOMPANYDETAILS: 'view.screen.MyCompanyDetails',
  VIEW_SCREEN_MYDETAILS: 'view.screen.MyDetails',
  VIEW_SCREEN_MYDEVICES: 'view.screen.MyDevices',
  VIEW_SCREEN_MYROLES: 'view.screen.MyRoles',
  VIEW_SCREEN_MYSCHEDULES: 'view.screen.MySchedules',
  VIEW_SCREEN_MYSUBSCRIPTIONDETAILS: 'view.screen.MySubscriptionDetails',
  VIEW_SCREEN_MYSUBSCRIPTIONS: 'view.screen.MySubscriptions',
  VIEW_SCREEN_NOTIFICATIONTHROUGHPUT: 'view.screen.NotificationThroughput',
  VIEW_SCREEN_ORDERDEVICES: 'view.screen.OrderDevices',
  VIEW_SCREEN_ORDERUSERPROTOCOLPROVIDERS:
    'view.screen.OrderUserProtocolProviders',
  VIEW_SCREEN_ORG_PLAN_OVERVIEW: 'view.screen.OrgPlanOverview',
  VIEW_SCREEN_PASSWORDPOLICY: 'view.screen.PasswordPolicy',
  VIEW_SCREEN_PASTALERTS: 'view.screen.PastAlerts',
  VIEW_SCREEN_PASTALERTSFORMYGROUPS: 'view.screen.PastAlertsForMyGroups',
  VIEW_SCREEN_PHONE_LOGIN: 'view.screen.PhoneLogin',
  VIEW_SCREEN_PHONELOGIN: 'view.screen.PhoneLogin',
  VIEW_SCREEN_PHONERECORDINGS: 'view.screen.PhoneRecordings',
  VIEW_SCREEN_PROTOCOLLEVELPROVIDERDETAILS:
    'view.screen.ProtocolLevelProviderDetails',
  VIEW_SCREEN_PROTOCOLLEVELPROVIDERS: 'view.screen.ProtocolLevelProviders',
  VIEW_SCREEN_QUOTAS: 'view.screen.Quotas',
  VIEW_SCREEN_ROLEDETAILS: 'view.screen.RoleDetails',
  VIEW_SCREEN_ROLES: 'view.screen.Roles',
  VIEW_SCREEN_SCENARIOATTACHMENTS: 'view.screen.ScenarioAttachments',
  VIEW_SCREEN_SCENARIODETAILS: 'view.screen.ScenarioDetails',
  VIEW_SCREEN_SCENARIOHANDLING: 'view.screen.ScenarioHandling',
  VIEW_SCREEN_SCENARIOINITIATORS: 'view.screen.ScenarioInitiators',
  VIEW_SCREEN_SCENARIOPREDICATES: 'view.screen.ScenarioPredicates',
  VIEW_SCREEN_SCENARIORECIPIENTS: 'view.screen.ScenarioRecipients',
  VIEW_SCREEN_SCENARIORESPONSES: 'view.screen.ScenarioResponses',
  VIEW_SCREEN_SCENARIOSTATUSSUMMARYREPORT:
    'view.screen.ScenarioStatusSummaryReport',
  VIEW_SCREEN_SCENARIOSUPERVISORS: 'view.screen.ScenarioSupervisors',
  VIEW_SCREEN_SCHEDULED_MESSAGE_DETAILS: 'view.screen.ScheduledMesageDetails',
  VIEW_SCREEN_SCHEDULEDMESAGEDETAILS: 'view.screen.ScheduledMesageDetails',
  VIEW_SCREEN_SEARCHDEVICESFORSCENARIO: 'view.screen.SearchDevicesForScenario',
  VIEW_SCREEN_SEARCHDYNAMICTEAMSFORSCENARIO:
    'view.screen.SearchDynamicTeamsForScenario',
  VIEW_SCREEN_SEARCHFASTACCESSSCENARIOS:
    'view.screen.SearchFastAccessScenarios',
  VIEW_SCREEN_SEARCHGROUPSFORSCENARIO: 'view.screen.SearchGroupsForScenario',
  VIEW_SCREEN_SEARCHSCENARIOS: 'view.screen.SearchScenarios',
  VIEW_SCREEN_SEARCHSUBSCRIPTIONDETAILS:
    'view.screen.SearchSubscriptionDetails',
  VIEW_SCREEN_SEARCHSUBSCRIPTIONMEMBERDEVICES:
    'view.screen.SearchSubscriptionMemberDevices',
  VIEW_SCREEN_SEARCHSUBSCRIPTIONMEMBERDYNAMICTEAMS:
    'view.screen.SearchSubscriptionMemberDynamicTeams',
  VIEW_SCREEN_SEARCHSUBSCRIPTIONMEMBERGROUPS:
    'view.screen.SearchSubscriptionMemberGroups',
  VIEW_SCREEN_SEARCHSUBSCRIPTIONMEMBERPERSONS:
    'view.screen.SearchSubscriptionMemberPersons',
  VIEW_SCREEN_SEARCHUSERPROTOCOLPROVIDERS:
    'view.screen.SearchUserProtocolProviders',
  VIEW_SCREEN_SEARCHWEBSERVICEUSERS: 'view.screen.SearchWebServiceUsers',
  VIEW_SCREEN_SECURITYAUDITREPORT: 'view.screen.SecurityAuditReport',
  VIEW_SCREEN_SELECTSITEFORSITEHOLIDAY: 'view.screen.SelectSiteForSiteHoliday',
  VIEW_SCREEN_SENTMESSAGEDETAILS: 'view.screen.SentMessageDetails',
  VIEW_SCREEN_SIGNUPFORALERTS: 'view.screen.SignupForAlerts',
  VIEW_SCREEN_SITEDETAILS: 'view.screen.SiteDetails',
  VIEW_SCREEN_SITEHOLIDAYS: 'view.screen.SiteHolidays',
  VIEW_SCREEN_SITEHOLIDAYSELECTION: 'view.screen.SiteHolidaySelection',
  VIEW_SCREEN_SITES: 'view.screen.Sites',
  VIEW_SCREEN_SMSKEYWORD: 'view.screen.SmsKeyword',
  VIEW_SCREEN_STANDARDWEBLOGIN: 'view.screen.StandardWebLogin',
  VIEW_SCREEN_SUBSCRIPTIONDOMAINADMINGROUPS:
    'view.screen.SubscriptionDomainAdminGroups',
  VIEW_SCREEN_SUBSCRIPTIONDOMAINDETAILS:
    'view.screen.SubscriptionDomainDetails',
  VIEW_SCREEN_SUBSCRIPTIONDOMAINS: 'view.screen.SubscriptionDomains',
  VIEW_SCREEN_SUPERADMINISTRATORDETAILS:
    'view.screen.SuperAdministratorDetails',
  VIEW_SCREEN_SUPERADMINISTRATORS: 'view.screen.SuperAdministrators',
  VIEW_SCREEN_SYNCHRONIZATIONREPORT: 'view.screen.SynchronizationReport',
  VIEW_SCREEN_SYSTEMAUDITREPORT: 'view.screen.SystemAuditReport',
  VIEW_SCREEN_TEAMDETAILS: 'view.screen.TeamDetails',
  VIEW_SCREEN_TEMPORARY_REPLACEMENT: 'view.screen.TemporaryReplacement',
  VIEW_SCREEN_TEMPORARYREPLACEMENTDETAILS:
    'view.screen.TemporaryReplacementDetails',
  VIEW_SCREEN_TIMEZONES: 'view.screen.TimeZones',
  VIEW_SCREEN_TUTORIALS: 'view.screen.Tutorials',
  VIEW_SCREEN_USER_API_KEYS: 'view.screen.UserAPIKeys',
  VIEW_SCREEN_USER_DEVICES: 'view.screen.UserDevices',
  VIEW_SCREEN_USER_PERFORMANCE_REPORT: 'view.screen.UserPerformanceReport',
  VIEW_SCREEN_USER_ROLES: 'view.screen.UserRoles',
  VIEW_SCREEN_USER_SCHEDULE: 'view.screen.UserSchedule',
  VIEW_SCREEN_USERDETAILS: 'view.screen.UserDetails',
  VIEW_SCREEN_USERDEVICES: 'view.screen.UserDevices',
  VIEW_SCREEN_USERLEVELPROVIDERDETAILS: 'view.screen.UserLevelProviderDetails',
  VIEW_SCREEN_USERLEVELPROVIDERS: 'view.screen.UserLevelProviders',
  VIEW_SCREEN_USERPERFORMANCEREPORT: 'view.screen.UserPerformanceReport',
  VIEW_SCREEN_USERROLES: 'view.screen.UserRoles',
  VIEW_SCREEN_USERS: 'view.screen.Users',
  VIEW_SCREEN_USERSCHEDULE: 'view.screen.UserSchedule',
  VIEW_SCREEN_VIEW_PERSON_SUPERVISORS: 'view.screen.ViewPersonSupervisors',
  VIEW_SCREEN_VIEWPERSONSUPERVISORS: 'view.screen.ViewPersonSupervisors',
  VIEW_SCREEN_VIEWSENTMESSAGES: 'view.screen.ViewSentMessages',
  VIEW_SCREEN_VIEWSENTSCENARIOS: 'view.screen.ViewSentScenarios',
  VIEW_SCREEN_VIEWSUBSCRIPTIONMANAGERS: 'view.screen.ViewSubscriptionManagers',
  VIEW_SCREEN_VIEWUSERSBYROLE: 'view.screen.ViewUsersByRole',
  VIEW_SCREEN_WEB_LOGIN: 'view.screen.WebLogin',
  VIEW_SCREEN_WEBLOGIN: 'view.screen.WebLogin',
  VIEW_SCREEN_WEBSERVICEUSERDETAILS: 'view.screen.WebServiceUserDetails',
  VIEW_SCREEN_WHOS_ON_DUTY: 'view.screen.WhosOnDuty',
  VIEW_SCREEN_WHOSONDUTY: 'view.screen.WhosOnDuty',
  VIEW_SCREEN_HISTORICAL_ONCALL: 'view.screen.HistoricalOnCall',
};

export default permissionConstants;

export const requiredGroupPermissions = [
  permissionConstants.VIEW_SCREEN_GROUPS,
  permissionConstants.VIEW_SCREEN_WHOS_ON_DUTY,
];
